import axios from 'axios';
import { API_BASE_URL } from '../constants';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        if (window.location.pathname !== '/login') {
          localStorage.removeItem('authToken');
          window.location.href = '/login';
        }
      } else if (error.response.status === 403) {
        if (error.response.data && error.response.data.message && error.response.data.message.includes('permission')) {
          if (window.location.pathname !== '/access-denied') {
            window.location.href = '/access-denied';
          }
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;